export default __webpack_public_path__ + "static/media/2383.a67d0902.png";